import Scene from "./scene";
import "./grain.css";
import "./layout.css";
import grainPattern from "./assets/paper-pattern.png";
import { useEffect } from "react";

export default function App() {
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--grain-pattern",
      `url(${grainPattern})`
    );
  }, []);

  return (
    <main className="h-screen w-screen">
      <div className="grain" />
      <header className="header">
        <span className="header-text">(Hello)</span>
      </header>
      <Scene />
      <footer className="footer">
        <span className="footer-text">hello (at) decode.technology</span>
        <span className="footer-text">25'</span>
      </footer>
    </main>
  );
}
